'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DataTBody: ()=>DataTBody,
    MemoizedTBody: ()=>MemoizedTBody
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../Table/index.cjs");
const external_utils_cjs_namespaceObject = require("./utils.cjs");
const external_DataTr_cjs_namespaceObject = require("./DataTr.cjs");
const external_DataAggregateRow_cjs_namespaceObject = require("./DataAggregateRow.cjs");
const external_DataTBody_context_cjs_namespaceObject = require("./DataTBody.context.cjs");
const DataTBody = ({ table })=>{
    const [collapsingRow, setCollapsingRow] = (0, external_react_namespaceObject.useState)(null);
    const context = (0, external_react_namespaceObject.useMemo)(()=>({
            collapsingRow,
            setCollapsingRow
        }), [
        collapsingRow,
        setCollapsingRow
    ]);
    const aggregatedData = (0, external_react_namespaceObject.useMemo)(()=>{
        const data = {
            top: {},
            bottom: {}
        };
        table.getAllColumns().forEach((column)=>{
            if (!column.columnDef.meta?.aggregate) return;
            const aggregationFn = column.columnDef.meta?.aggregate?.fn;
            const position = column.columnDef.meta?.aggregate?.position || 'bottom';
            const value = aggregationFn ? (0, external_utils_cjs_namespaceObject.getAggregationValue)(table, column.id, aggregationFn) : column.columnDef.meta?.aggregate?.cell;
            if (Array.isArray(position)) position.forEach((p)=>{
                data[p][column.id] = value;
            });
            else data[position][column.id] = value;
        });
        return data;
    }, [
        table,
        table.options.data
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DataTBody_context_cjs_namespaceObject.DataTBodyContext.Provider, {
        value: context,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(index_cjs_namespaceObject.TBody, {
            children: [
                aggregatedData && Object.keys(aggregatedData.top).length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DataAggregateRow_cjs_namespaceObject.DataAggregateRow, {
                    position: "top",
                    table: table,
                    aggregatedData: aggregatedData
                }),
                table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DataTr_cjs_namespaceObject.DataTr, {
                        table: table,
                        row: row
                    }, row.id)),
                aggregatedData && Object.keys(aggregatedData.bottom).length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DataAggregateRow_cjs_namespaceObject.DataAggregateRow, {
                    position: "bottom",
                    table: table,
                    aggregatedData: aggregatedData
                })
            ]
        })
    });
};
const TBodyWrapper = ({ table })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DataTBody, {
        table: table
    });
const MemoizedTBody = /*#__PURE__*/ (0, external_react_namespaceObject.memo)(TBodyWrapper, (prev, next)=>prev.table.options.data === next.table.options.data && prev.rowCount === next.rowCount && prev.rowSelection === next.rowSelection && prev.columns === next.columns);
exports.DataTBody = __webpack_exports__.DataTBody;
exports.MemoizedTBody = __webpack_exports__.MemoizedTBody;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DataTBody",
    "MemoizedTBody"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
